module.exports = __webpack_public_path__ + "img/bootstrap-4.627add45.svg";